/**
 * this is the top bar menu item component for the topbar
 *
 * Created by Tom on 06/06/18
 */

import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

// style import
import './style.scss'


const TopBarMenuItem = ({leftIcon, leftIconAlt, leftIconClass, rightIcon, rightIconAlt, rightIconClass, menuItem, pathname, onClick}) => {

    // check of prop menuText exist
    const menuText = menuItem ? menuItem.menuText : null

    // check if current path equals the menuItem.route and if yes set CSS active
    const dynClass = cx(
        'top-bar-menu-item',
        {'top-bar-menu-item--active': menuItem.route === pathname}
    )

    return (
        <a href=""
           className={dynClass}
           onClick={e => {
               // do not refresh page
               e.preventDefault();
               e.stopPropagation();
               // delegate click event
               onClick(menuItem.route)
           }}
        >
            {
                (leftIcon
                        ?
                        <img
                            src={leftIcon}
                            className={leftIconClass}
                            alt={leftIconAlt}
                        />
                        :
                        null
                )
            }
            <span className="top-bar-menu-item__text">{menuText}</span>
            {
                (rightIcon
                        ?
                        <img
                            src={rightIcon}
                            className={rightIconClass}
                            alt={rightIconAlt}
                        />
                        :
                        null
                )
            }
        </a>
    )
}

// define the prop types
TopBarMenuItem.propTypes = {
    menuItem: PropTypes.object,
    pathname: PropTypes.string,
    onClick: PropTypes.func
}

export default TopBarMenuItem



// WEBPACK FOOTER //
// ./src/components/TopBarMenuItem/index.js